import { createContext } from "react";
import { AdminObject, LogObject } from "../../types/models";
export const LogsContext = createContext({
  admin: AdminObject,
  logs: Array<typeof LogObject>(),
  refreshLogs:()=>{}
});
